import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import { Dropdown, Menu } from 'antd'
import pluralize from 'pluralize'
import { AiOutlineDown } from 'react-icons/ai'

import { useListData, usePet, useToggle } from '../modules'

import FilterButton from '../partials/actions/FilterButton'

import RequestItems from '../components/modals/requestItems'
import NewInventoryItem from '../components/modals/newinventoryitem'
import RecordSpoilage from '../components/modals/recordspoilage'
import ModifyQuantity from '../components/modals/modifyquantity'
import RestockItem from '../components/modals/restockitem'
import Receive from '../components/resusable/receive'
import Request from '../components/modals/request'

const Requests = () => {
    const { user } = useSelector(state => state.application)

    const [type, setType] = useState({ label: 'All', value: 'All' })
    const [selected, setSelected] = useState()
    const [store, setStore] = useState(user.stores.length > 0 ? { ...user.stores[0], label: user.stores[0].name, value: user.stores[0]._id } : null)
    const [stores] = useState(user.stores.map(store => ({ ...store, label: store.name, value: store._id })))

    const [restockModal, toggleRestockModal] = useToggle()
    const [modifyQuantityModal, toggleModifyQuantityModal] = useToggle()
    const [rqModal, toggleRqModal] = useToggle()
    const [spoilageModal, toggleSpoilageModal] = useToggle()
    const [requestModal, toggleRequestModal] = useToggle()

    const [
        { loading: invLoading, error: invError, fetch },
        { list: requests },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('requestsByStore', {
        store: store?._id,
        type: type?.label
    }, { notify: true, manual: store === null }, 'requests')

    const changeType = val => {
        setType(val)
        navigate(1)
        fetch()
    }

    const selectStore = val => {
        setStore(val)
        navigate(1)
        fetch()
    }

    const onComplete = ({ }, notif, ops) => {
        notif('Request has been marked as seen', ops('success'))
        fetch()
    }

    const [{ loading }, markRequestAsSeen] = usePet('markRequestAsSeen', {
        id: selected?._id
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Marking request...' } })

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <ModifyQuantity
                toggle={toggleModifyQuantityModal}
                visible={modifyQuantityModal} />
            <RestockItem
                toggle={toggleRestockModal}
                visible={restockModal} />
            <RecordSpoilage
                toggle={toggleSpoilageModal}
                visible={spoilageModal} />
            <RequestItems
                store={store}
                onPerform={fetch}
                toggle={toggleRequestModal}
                visible={requestModal} />
            {
                rqModal &&
                <Request
                    request={ selected }
                    toggle={toggleRqModal}
                    visible={rqModal} />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <Select
                        value={type}
                        onChange={changeType}
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                        options={['All', 'Sent', 'Received'].map(type => ({ label: type, value: type }))}
                        placeholder="Select Type" />
                    <button onClick={toggleRequestModal} className="btn hisani-btn-green text-white">
                        <span className="hidden xs:block ml-2">Request Items</span>
                    </button>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Item Requests</h2>
                    <Select
                        value={store}
                        onChange={selectStore}
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                        options={stores}
                        placeholder="Select Store" />
                </header>
                <div className="p-3">

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <Receive
                            error={invError}
                            loading={invLoading}
                            progress>
                            <table className="table-auto w-full">
                                {/* Table header */}
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">No</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Requested By</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Destination</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Sent From</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Status</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center"></div>
                                        </th>
                                    </tr>
                                </thead>
                                {/* Table body */}
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        requests.map((request, key) =>
                                            <tr>
                                                <td className="p-2">
                                                    <div className="text-center">{key + 1}.</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{request.requestedBy.name}</div>
                                                    <p className="text-gray-500 text-xs italic">{request.requests.length} {pluralize('requests', request.requests.length)}</p>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{request.destination.name}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{request.source.name}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className={`${request.seen ? 'text-green-500' : 'text-yellow-500'} text-center`}>{request.seen ? 'Seen' : 'Pending'}</div>
                                                </td>
                                                <td className="p-2 text-center">
                                                    <Dropdown
                                                        overlay={
                                                            <Menu>
                                                                <Menu.Item onClick={() => {
                                                                    setSelected(request)
                                                                    toggleRqModal()
                                                                }}>View</Menu.Item>
                                                                {
                                                                    request.source.name !== store.name &&
                                                                    <>
                                                                        <Menu.Item onClick={() => {
                                                                            setSelected(request)
                                                                            markRequestAsSeen()
                                                                        }}>Mark as Seen</Menu.Item>
                                                                    </>
                                                                }
                                                            </Menu>
                                                        }>
                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </Receive>
                        {Paginate}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Requests